// @ts-nocheck

import React from "react";
import {
  ButtonsFilterWrapper,
  HeaderFilterWrapper,
  OrderFilterWrapper,
} from "./styles";
import SelectButton from "Components/atoms/SelectButton";
import { FlightDetailsHeaderMobile } from "Components/molecules/FlightDetailsHeader/mobile";
import { HeaderFilterMobileProps } from "./types";
import { useFilterContext } from "shared/contexts/FilterContext";
import { useSearchContext } from "shared/contexts/SearchContext";
import { SERPResult } from "shared/types/serpResult";
import { SearchOrderSelector } from "Components/molecules/ProgressBar";

export const HeaderFilterMobile: React.FC<HeaderFilterMobileProps> = ({
  onOpenFilterModal,
  selectedOrder,
  onOrderChange,
}) => {
  const {
    setAnchorFilterMobile,
    setStops,
    stops,
    priceRange,
    airportsFrom,
    airportsTo,
    airlines,
    sellers,
    firstSectorTimeRange,
    secondSectorTimeRange,
    minPrice,
    maxPrice,
  } = useFilterContext();

  const { filteredFlightResults, setFilteredFlightResults } =
    useSearchContext();

  const openFilterModal = (anchorFilterMobile?: string) => {
    setAnchorFilterMobile(anchorFilterMobile ?? "default");
    onOpenFilterModal();
  };

  const handleOnlyDirectFlightsToggle = (isChecked: boolean) => {
    const newStops = isChecked ? [0] : [0, 1, 2, 3];
    setStops(newStops);

    setFilteredFlightResults((prev) => {
      if (!prev) return null;

      return {
        ...prev,
        appliedFilters: {
          ...prev.appliedFilters,
          stops: newStops,
        },
      };
    });
  };

  const applied = filteredFlightResults?.appliedFilters;

  const compareArrays = (a: any[] = [], b: any[] = []) =>
    JSON.stringify([...a].sort()) !== JSON.stringify([...b].sort());

  const isOnlyDirect = applied?.stops?.length === 1 && applied?.stops[0] === 0;

  let count = 0;

  if (applied?.stops && compareArrays(applied.stops, [0, 1, 2, 3])) count++;

  if (
    typeof applied?.priceFrom === "number" &&
    typeof applied?.priceTo === "number" &&
    (applied.priceFrom !== minPrice || applied.priceTo !== maxPrice)
  )
    count++;

  if (
    applied?.airportsFrom &&
    compareArrays(
      applied.airportsFrom,
      airportsFrom.map((a) => a.iata),
    )
  )
    count++;

  if (
    applied?.airportsTo &&
    compareArrays(
      applied.airportsTo,
      airportsTo.map((a) => a.iata),
    )
  )
    count++;

  if (
    applied?.airlines &&
    compareArrays(
      applied.airlines,
      airlines.map((a) => a.id),
    )
  )
    count++;

  if (
    applied?.sellers &&
    compareArrays(
      applied.sellers,
      sellers.map((s) => s.id),
    )
  )
    count++;

  if (
    typeof applied?.firtsSectorDepartureTimeFrom === "number" &&
    typeof applied?.firtsSectorDepartureTimeTo === "number" &&
    (applied.firtsSectorDepartureTimeFrom !== 0 ||
      applied.firtsSectorDepartureTimeTo !== 1439)
  )
    count++;

  if (
    typeof applied?.secondSectorDepartureTimeFrom === "number" &&
    typeof applied?.secondSectorDepartureTimeTo === "number" &&
    (applied.secondSectorDepartureTimeFrom !== 0 ||
      applied.secondSectorDepartureTimeTo !== 1439)
  )
    count++;

  return (
    <HeaderFilterWrapper>
      <FlightDetailsHeaderMobile />
      <OrderFilterWrapper>
        <SearchOrderSelector
          selectedOrder={selectedOrder}
          onOrderChange={onOrderChange}
        />
      </OrderFilterWrapper>
      <ButtonsFilterWrapper>
        <SelectButton
          label={count > 0 ? `${count} filtros` : "Filtros"}
          isChecked={false}
          onClick={() => openFilterModal("default")}
          size={100}
        />
        <SelectButton
          withCheckBox
          label="Só diretos"
          isChecked={isOnlyDirect}
          onChange={handleOnlyDirectFlightsToggle}
        />
        <SelectButton
          label="Preço"
          isChecked={false}
          onClick={() => openFilterModal("price")}
          size={100}
        />
        <SelectButton
          label="Aeroportos"
          isChecked={false}
          onClick={() => openFilterModal("airports")}
          size={100}
        />
        <SelectButton
          label="Horários"
          isChecked={false}
          onClick={() => openFilterModal("times")}
          size={100}
        />
        <SelectButton
          label="Vendedor"
          isChecked={false}
          onClick={() => openFilterModal("sellers")}
          size={100}
        />
      </ButtonsFilterWrapper>
    </HeaderFilterWrapper>
  );
};

export default HeaderFilterMobile;
